import { lazy } from "react"

// TripPage is the entire interactive planner (~620 KB gzip: Google Maps, dnd,
// HeroUI, the whole editor). The route tree statically imports every route
// module, so a plain `import { TripPage }` in the trip/guide routes pulled this
// chunk into the static graph of `main` — and therefore onto home and
// /trips/explore, which never render it (the June 2026 bundle-perf fix). Loading
// it lazily keeps it off every page that doesn't actually mount the planner.
export const TripPage = lazy(() =>
  import(`./TripPage`).then((m) => ({ default: m.TripPage }))
)
